export function insertItem(array, action) {
    const newArray = array.slice();
    newArray.splice(action.index, 0, action.item);
    return newArray;
}

export function removeItem(array, action) {
    return array.filter((item, index) => index !== action.index);
}
